import * as tslib_1 from "tslib";
import { AbstractSearchCriteria } from './abstract-search-criteria';
var DispatchEntrySearchCriteria = /** @class */ (function (_super) {
    tslib_1.__extends(DispatchEntrySearchCriteria, _super);
    function DispatchEntrySearchCriteria() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return DispatchEntrySearchCriteria;
}(AbstractSearchCriteria));
export { DispatchEntrySearchCriteria };
